import { render, staticRenderFns } from "./RegistroPersonal.vue?vue&type=template&id=9ebbba2e"
import script from "./RegistroPersonal.vue?vue&type=script&lang=js"
export * from "./RegistroPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports